import ReactDOM from "react-dom";
import Button from "./Button";
import { useSelector } from "react-redux";
import {
  selectIsRightPanelExpanded,
  expandRightPanel,
  collapseRightPanel,
} from "../app/layoutSlice";
import { useDispatch } from "react-redux";
import classNames from "classnames";
import styles from "./rightPanel.module.css";

const RightPanel = ({ children }) => {
  const dispatch = useDispatch();
  const rightPanelExpanded = useSelector(selectIsRightPanelExpanded);

  const handleExpandToggle = () => {
    if (rightPanelExpanded) {
      dispatch(collapseRightPanel());
    } else {
      dispatch(expandRightPanel());
    }
  };

  return ReactDOM.createPortal(
    <div
      className={classNames(styles.rightPanel, {
        [styles.collapsed]: !rightPanelExpanded,
      })}
    >
      <div
        style={{
          overflow: "hidden",
          height: "calc(100% - 300px)",
          display: "flex",
          flexDirection: "column",
          flexShrink: "1",
          flexGrow: "1",
          position: "relative",
        }}
      >
        <div
          style={{
            width: "100%",
            maxHeight: "calc(100% - 70px)",
            display: "flex",
            paddingTop: "20px",
          }}
        >
          {children}
        </div>
        <div
          style={{
            marginTop: "auto",
            flexShrink: 0,
            height: "40px",
          }}
        >
          <Button
            onClick={handleExpandToggle}
            icon={rightPanelExpanded ? "chevronRight" : "chevronLeft"}
          />
        </div>
      </div>
    </div>,
    document.getElementById("rightPanel")
  );
};

export default RightPanel;
